import * as React from "react";
const SvgMove = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M9 3 5 6.99h3V14h2V6.99h3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgMove as ReactComponent };